export default {"src":"/_next/static/media/apple_download_badge.c9fdae0d.svg","height":36,"width":112,"blurWidth":0,"blurHeight":0};